import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { RutValidator } from 'ng9-rut';
import { ContactService } from 'src/app/services/contact.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { NewRegistrationService } from 'src/app/services/new-registration.service';
declare var $: any;

@Component({
  selector: 'app-preregister',
  templateUrl: './preregister.component.html',
  styleUrls: ['./preregister.component.css']
})
export class PreRegisterComponent implements OnInit {
  guardar = false;
  siteKey: string;
  progress = false;
  ContactForm: FormGroup;
  validarionsRut: any;
  progressValidacion: boolean = false

  mensajes: any = {
    showEnListaEspera: false,
    showSelecciondo: false,
    showSuccess: false,
    showError: false,
    mensaje: ''
  }

  private rutValidator: RutValidator
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private contact: ContactService,
    rutValidator: RutValidator,
    private alerts: ToastrService,
    private auth: AuthService,
    private newRegistrationService: NewRegistrationService
  ) {
    this.siteKey = '6LfxwdQZAAAAANiJELiajiQagFv1tsWk9a4Gr6wX';
    this.rutValidator = rutValidator
  }

  ngOnInit(): void {
    this.createForm();
    this.formChangesSubscriptions()
    this.ContactForm.get('Nacionalidad').setValue('1')
  }

  createForm() {
    this.validarionsRut = this.rutValidator;
    this.ContactForm = this.fb.group({
      Nacionalidad: ['1'],
      RUT: [''],
      Pasaporte: [''],
      Captcha: ['', Validators.required],
    });
  }

  formChangesSubscriptions() {
    this.ContactForm.get("Nacionalidad").valueChanges
      // .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((nacionalidad: string) => {
        const esRut = nacionalidad === '1'

        this.clearMensajes()
        this.clearForm()
        this.clearValidators()

        if (esRut)
          this.setRutValidators()
        else
          this.setPasaporteValidators()
      })
  }

  clearValidators() {
    this.ContactForm.get('RUT').setValidators(null)
    this.ContactForm.get('Pasaporte').setValidators(null)
  }

  setRutValidators() {
    this.ContactForm.get('RUT').setValidators([
      Validators.required,
      Validators.maxLength(50),
      this.validarionsRut,
      Validators.minLength(3),
    ])
  }

  setPasaporteValidators() {
    this.ContactForm.get('Pasaporte').setValidators([
      Validators.required,
      Validators.maxLength(50),
      Validators.minLength(3),
    ])
  }

  clearMensajes() {
    if (!this.mensajes) return
    this.mensajes.showEnListaEspera = false
    this.mensajes.showSelecciondo = false
    this.mensajes.showSuccess = false
    this.mensajes.showError = false
    this.mensajes.mensaje = ''
  }

  clearForm() {
    this.clearField('RUT', '')
    this.clearField('Pasaporte', '')
  }

  clearField(field: string, value: any) {
    this.ContactForm.get(field).setValue(value);
    this.ContactForm.get(field).markAsUntouched()
    this.ContactForm.get(field).markAsPristine()
  }

  resolved(captchaResponse: string) {
    // This is intentional
  }

  clearRut() {
    if (!this.ContactForm.controls.RUT.valid) {
      this.ContactForm.controls.RUT.setValue('');
    }
  }

  clearPasaporte() {
    if (!this.ContactForm.controls.Pasaporte.valid) {
      this.ContactForm.controls.Pasaporte.setValue('');
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  get disableApiButton() {
    return false
  }

  async validateEmailDemre() {
    this.clearMensajes()
    this.validateAllFormFields(this.ContactForm);
    const esRut = this.ContactForm.get('Nacionalidad').value === '1'
    const esCent = true;
    if (!this.ContactForm.get('Captcha').valid)
      return
    if (esRut && !this.ContactForm.get('RUT').valid)
      return
    if (!esRut && !this.ContactForm.get('Pasaporte').valid)
      return

    this.progressValidacion = true

    let rutcumpleto: any = ''
    let rut = ''
    let dv = ''

    if (esRut) {
      rutcumpleto = this.ContactForm.controls.RUT.value;
      rut = rutcumpleto.replaceAll('.', '').replaceAll('-', '').slice(0, -1);
      dv = rutcumpleto.slice(-1);
    } else {
      rutcumpleto = this.ContactForm.controls.Pasaporte.value;
      rut = rutcumpleto.replaceAll('.', '').replaceAll('-', '')
    }

    const { Error, MensajeRetorno }: any = await this.newRegistrationService.ValidateEmailDemre(rut, dv, esCent, !esRut).toPromise()
    this.progressValidacion = false

    this.mensajes.mensaje = MensajeRetorno

    if (Error)
      this.mensajes.showError = true
    else
      this.mensajes.showSuccess = true

    this.ContactForm.get('Captcha').setValue('')
  }

  returnToLogin() {
    this.router.navigateByUrl('/');
  }
}
